<script setup>
/* global axios */
// Icerik > Takvim: YALNIZCA zamanlanmis gonderiler.
//
// Menudeki genel Takvim ile karisan bir ekran DEGIL. Genel takvim
// hatirlatma / randevu / gonderi hepsini gosterir; burasi tek bir soruyu
// cevaplar: "onumuzdeki gunlerde ne yayinlanacak". Bu yuzden veriyi ayni
// ucdan ama `tur=gonderi` suzgeciyle cekiyoruz - sunucu da o turdeki kayitlari
// yalnizca durum='planlandi' gonderilerden turetiyor (OmnupGonderi
// takvimi_esitle).
//
// Ay izgarasini TEKRAR YAZMIYORUZ: TakvimAy.vue zaten 42 hucrelik izgarayi,
// cok gunlu kayitlari, "+N daha" acilimini ve bugun vurgusunu cozuyor. Ayni
// izgaranin ikinci bir kopyasi, birinde duzeltilen bir tarih hatasinin
// digerinde kalmasi demekti.
//
// Ham 'axios' PAKETINI ice aktarmiyoruz. Chatwoot kimlik basliklarini
// window.axios uzerinde tutuyor; paketten gelen ornek 401 doner.
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import Button from 'dashboard/components-next/button/Button.vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
// Izgara Takvim bolumunun klasorunde duruyor (routes/dashboard/takvim/).
// Kopyasini buraya almiyoruz: ayni tarih matematiginin iki kopyasi, birinde
// duzeltilen bir hatanin digerinde kalmasi demek.
import TakvimAy from '../takvim/TakvimAy.vue';
import {
  DURUM_ANAHTARLARI,
  DURUM_RENKLERI,
  HEDEF_DURUM_ANAHTARLARI,
  HEDEF_DURUM_RENKLERI,
  bicimDiliCoz,
  duzenlenebilir,
  gunAnahtari,
  hataMetniniCoz,
  hedefAnahtari,
  platformSimgesi,
  zamanMetni,
} from './icerik-ortak';

const { t, locale } = useI18n();
const route = useRoute();
const router = useRouter();

const accountId = computed(() => route.params.accountId);
const takvimUcu = computed(() => `/api/v1/accounts/${accountId.value}/takvim`);
const icerikUcu = computed(() => `/api/v1/accounts/${accountId.value}/icerik`);

const iki = sayi => String(sayi).padStart(2, '0');

// --- ay durumu -------------------------------------------------------------

const simdi = new Date();
const odakYil = ref(simdi.getFullYear());
const odakAy = ref(simdi.getMonth());

const kayitlar = ref([]);
const yukleniyor = ref(false);
const hata = ref('');

const ayAnahtari = computed(() => `${odakYil.value}-${iki(odakAy.value + 1)}`);

const ayBasligi = computed(() => {
  const ilk = new Date(odakYil.value, odakAy.value, 1);
  try {
    return ilk.toLocaleDateString(bicimDiliCoz(locale.value), {
      month: 'long',
      year: 'numeric',
    });
  } catch (e) {
    return ilk.toLocaleDateString('tr-TR', { month: 'long', year: 'numeric' });
  }
});

// Izgarada onceki/sonraki ayin gunleri de gorunuyor. Istegi o 42 gunun
// tamamini kapsayacak sekilde atiyoruz; yalnizca ayin 1'i ile son gunu
// arasini isteseydik izgaranin ilk ve son satiri hep bos gorunurdu.
const aralik = () => {
  const ayinIlki = new Date(odakYil.value, odakAy.value, 1);
  const kaydir = (ayinIlki.getDay() + 6) % 7;
  const bas = new Date(odakYil.value, odakAy.value, 1 - kaydir, 0, 0, 0, 0);
  const bit = new Date(
    bas.getFullYear(),
    bas.getMonth(),
    bas.getDate() + 41,
    23,
    59,
    59,
    999
  );
  return { bas: bas.toISOString(), bit: bit.toISOString() };
};

// Ay hizli degistirildiginde gec donen eski yanit yeni listenin uzerine
// yazmasin diye her istege sira numarasi veriyoruz.
let istekSayaci = 0;
const yuklenenAy = ref('');

const yukle = async (zorla = false) => {
  if (!zorla && yuklenenAy.value === ayAnahtari.value) return;

  const sira = (istekSayaci += 1);
  const istenenAy = ayAnahtari.value;
  yukleniyor.value = true;
  hata.value = '';
  const { bas, bit } = aralik();

  try {
    // tur=gonderi: bu ekranda hatirlatma ve randevu ISTEMIYORUZ. Onlari
    // istemciden ayiklamak, sunucudan gereksiz veri cekip kullaniciya da
    // "neden burada yok" sorusunu birakirdi.
    const { data } = await axios.get(takvimUcu.value, {
      params: { bas, bit, tur: 'gonderi' },
    });
    if (sira !== istekSayaci) return;
    kayitlar.value = data.kayitlar || [];
    yuklenenAy.value = istenenAy;
  } catch (e) {
    if (sira !== istekSayaci) return;
    hata.value = hataMetniniCoz(e, t('ICERIK.HATA_BILINMEYEN'));
    // Basarisiz istek "bu ay yuklendi" sayilmamali; yoksa kullanici aya geri
    // dondugunde sessiz bos bir ekranla kalirdi.
    yuklenenAy.value = '';
  } finally {
    if (sira === istekSayaci) yukleniyor.value = false;
  }
};

onMounted(() => yukle());

const ayDegistir = adim => {
  // Gun 1 uzerinden ilerliyoruz: ayin 31'inden ay eksiltmek Date'te bir
  // sonraki aya tasiyor (31 Mart - 1 ay = 3 Mart).
  const yeni = new Date(odakYil.value, odakAy.value + adim, 1);
  odakYil.value = yeni.getFullYear();
  odakAy.value = yeni.getMonth();
  paneliKapat();
  yukle();
};

const buguneGit = () => {
  const bugun = new Date();
  odakYil.value = bugun.getFullYear();
  odakAy.value = bugun.getMonth();
  paneliKapat();
  yukle();
};

// --- gonderi paneli --------------------------------------------------------

// Takvim kaydi gonderinin YANSIMASI: yalnizca baslik ve zaman tasiyor.
// Hedefler, hata metni ve medya gonderinin kendisinde. Panel acilinca
// gonderiyi ceviyoruz - 42 hucrelik izgara icin her gonderiyi onceden
// yuklemek, kullanicinin hicbirine bakmayacagi bir sorgu yigini demekti.
const gonderi = ref(null);
const gonderiYukleniyor = ref(false);
const gonderiHatasi = ref('');
const seciliGun = ref('');

const panelAcik = computed(
  () => Boolean(gonderi.value) || gonderiYukleniyor.value || Boolean(gonderiHatasi.value)
);

const paneliKapat = () => {
  gonderi.value = null;
  gonderiHatasi.value = '';
  gonderiYukleniyor.value = false;
  seciliGun.value = '';
};

const kaydiAc = async kayit => {
  // kaynak_id gonderinin kimligi; takvim kaydinin kendi id'si degil. Ikisini
  // karistirmak baska bir gonderiyi acardi.
  const kimlik = kayit?.kaynak_id;
  const bas = kayit?.baslangic ? new Date(kayit.baslangic) : null;
  seciliGun.value =
    bas && !Number.isNaN(bas.getTime()) ? gunAnahtari(bas) : '';

  if (!kimlik) {
    gonderi.value = null;
    gonderiHatasi.value = t('ICERIK.TAKVIM_KAYNAK_YOK');
    return;
  }

  gonderi.value = null;
  gonderiHatasi.value = '';
  gonderiYukleniyor.value = true;
  try {
    const { data } = await axios.get(`${icerikUcu.value}/${kimlik}`);
    gonderi.value = data || null;
  } catch (e) {
    gonderiHatasi.value = hataMetniniCoz(e, t('ICERIK.HATA_BILINMEYEN'));
  } finally {
    gonderiYukleniyor.value = false;
  }
};

// Bos bir gune tiklamak "bu gune icerik planla" demektir; kullaniciyi Olustur
// ekranina goturuyoruz.
//
// Secilen gunu `?zaman=` ile tasiyoruz. Olustur bugun bu parametreyi
// OKUMUYOR; okudugunda tarih alani hazir gelir, okumadiginda da kullanici
// dogru ekranda olur. Tiklandiginda hicbir sey yapmayan bir alan
// birakmiyoruz - tiklama her halukarda anlamli bir yere goturuyor.
const gunePlanla = anahtar => {
  if (!anahtar) return;
  router.push({
    name: 'icerik_olustur',
    params: { accountId: accountId.value },
    query: { zaman: `${anahtar}T09:00` },
  });
};

// Olustur ekrani duzenlenecek gonderiyi `?id=` ile okuyor (IcerikOlustur.vue
// icindeki acilistakiId). Listedeki `?gonderi=` ile ayni sey DEGIL: o, liste
// ekraninda hangi satirin one cikacagini soyluyor.
const duzenle = () => {
  if (!gonderi.value) return;
  router.push({
    name: 'icerik_olustur',
    params: { accountId: accountId.value },
    query: { id: gonderi.value.id },
  });
};

const listedeAc = () => {
  if (!gonderi.value) return;
  router.push({
    name: 'icerik_liste',
    params: { accountId: accountId.value },
    query: { gonderi: gonderi.value.id },
  });
};

// --- gorunum yardimcilari --------------------------------------------------

const durumMetni = g => t(DURUM_ANAHTARLARI[g.durum] || 'ICERIK.DURUM_TASLAK');
const durumRengi = g => DURUM_RENKLERI[g.durum] || DURUM_RENKLERI.taslak;

const hedefDurumMetni = h =>
  t(HEDEF_DURUM_ANAHTARLARI[h.durum] || 'ICERIK.HEDEF_BEKLIYOR');
const hedefRengi = h =>
  HEDEF_DURUM_RENKLERI[h.durum] || HEDEF_DURUM_RENKLERI.bekliyor;

const zaman = deger => zamanMetni(deger, locale.value);
</script>

<template>
  <div class="flex flex-col gap-4 p-6">
    <div class="flex flex-wrap items-center gap-2">
      <Button
        size="sm"
        variant="faded"
        icon="i-lucide-chevron-left"
        :aria-label="t('ICERIK.ONCEKI_AY')"
        @click="ayDegistir(-1)"
      />
      <span
        class="min-w-[9.5rem] text-sm font-medium text-center capitalize text-n-slate-12"
      >
        {{ ayBasligi }}
      </span>
      <Button
        size="sm"
        variant="faded"
        icon="i-lucide-chevron-right"
        :aria-label="t('ICERIK.SONRAKI_AY')"
        @click="ayDegistir(1)"
      />
      <Button
        size="sm"
        variant="ghost"
        color="slate"
        :label="t('ICERIK.BUGUN')"
        @click="buguneGit"
      />

      <span class="grow" />

      <Button
        size="sm"
        variant="faded"
        icon="i-lucide-refresh-cw"
        :label="t('ICERIK.YENILE')"
        :disabled="yukleniyor"
        @click="yukle(true)"
      />
      <Button
        size="sm"
        variant="solid"
        icon="i-lucide-plus"
        :label="t('ICERIK.SEKME_OLUSTUR')"
        @click="
          router.push({ name: 'icerik_olustur', params: { accountId } })
        "
      />
    </div>

    <p class="text-xs text-n-slate-11">{{ t('ICERIK.TAKVIM_ACIKLAMA') }}</p>

    <p v-if="hata" class="text-sm text-n-ruby-11">{{ hata }}</p>

    <div
      class="grid gap-6"
      :class="panelAcik ? 'xl:grid-cols-[minmax(0,1fr)_24rem]' : ''"
    >
      <section class="min-w-0">
        <!-- Ilk yuklemede izgara yerine bekleme isareti. Sonraki ay
             gecislerinde izgarayi KALDIRMIYORUZ: ekranin bos yanip sonmesi
             gezinmeyi yavas hissettiriyor. -->
        <div
          v-if="yukleniyor && !kayitlar.length"
          class="flex justify-center p-10"
        >
          <Spinner class="text-n-brand" />
        </div>

        <template v-else>
          <TakvimAy
            :yil="odakYil"
            :ay="odakAy"
            :kayitlar="kayitlar"
            :secili="seciliGun"
            @gun-secildi="gunePlanla"
            @kayit-secildi="kaydiAc"
          />

          <!-- Bu ayda hic zamanlanmis icerik yoksa izgara sessizce bos
               kalirdi. "Henuz icerik yok"tan FARKLI bir mesaj: burada
               suzgec AY; baska ayda icerik olabilir. -->
          <p v-if="!kayitlar.length" class="mt-3 text-xs text-n-slate-11">
            {{ t('ICERIK.TAKVIM_AY_BOS') }}
          </p>
        </template>
      </section>

      <!-- Gonderi paneli -->
      <aside
        v-if="panelAcik"
        class="flex flex-col gap-3 p-4 border rounded-lg h-fit border-n-weak bg-n-solid-1"
      >
        <div class="flex items-start gap-2">
          <h2 class="text-sm font-medium text-n-slate-12">
            {{ t('ICERIK.TAKVIM_PANEL_BASLIK') }}
          </h2>
          <span class="grow" />
          <Button
            size="xs"
            variant="ghost"
            color="slate"
            icon="i-lucide-x"
            :aria-label="t('ICERIK.KAPAT')"
            @click="paneliKapat"
          />
        </div>

        <div v-if="gonderiYukleniyor" class="flex justify-center p-6">
          <Spinner class="text-n-brand" />
        </div>

        <p v-else-if="gonderiHatasi" class="text-sm text-n-ruby-11">
          {{ gonderiHatasi }}
        </p>

        <template v-else-if="gonderi">
          <div class="flex flex-wrap items-center gap-2">
            <span
              class="px-2 py-0.5 text-xs rounded-md"
              :class="durumRengi(gonderi)"
            >
              {{ durumMetni(gonderi) }}
            </span>
            <span v-if="gonderi.yayin_zamani" class="text-xs text-n-slate-11">
              {{ zaman(gonderi.yayin_zamani) }}
            </span>
          </div>

          <p class="text-sm whitespace-pre-line text-n-slate-12">
            {{ gonderi.metin || t('ICERIK.METINSIZ') }}
          </p>

          <div v-if="gonderi.medya && gonderi.medya.length" class="flex flex-wrap gap-2">
            <template v-for="medya in gonderi.medya" :key="medya.id">
              <img
                v-if="medya.tur === 'gorsel' && medya.url"
                :src="medya.url"
                :alt="medya.ad || ''"
                class="object-cover rounded size-14 bg-n-alpha-1"
              />
              <span
                v-else
                class="grid rounded size-14 place-content-center bg-n-alpha-1 text-n-slate-11"
                :title="medya.ad || ''"
              >
                <span class="i-lucide-video size-5" />
              </span>
            </template>
          </div>

          <ul class="flex flex-col gap-2">
            <li
              v-for="hedef in gonderi.hedefler"
              :key="hedefAnahtari(hedef)"
              class="flex flex-col gap-1 p-2 rounded-md bg-n-alpha-1"
            >
              <span class="flex items-center gap-1.5 text-xs">
                <span
                  :class="platformSimgesi(hedef.platform)"
                  class="size-3.5 text-n-slate-11"
                />
                <span class="truncate text-n-slate-12">{{ hedef.ad }}</span>
                <span class="grow" />
                <span :class="hedefRengi(hedef)">
                  {{ hedefDurumMetni(hedef) }}
                </span>
              </span>
              <!-- Hata metni KIRMIZI ve acik; gizlenirse kullanici neyi
                   duzeltecegini bilemez. -->
              <span v-if="hedef.hata" class="text-xs text-n-ruby-11">
                {{ hedef.hata }}
              </span>
              <a
                v-else-if="hedef.dis_url"
                :href="hedef.dis_url"
                target="_blank"
                rel="noopener noreferrer"
                class="text-xs underline text-n-blue-11"
              >
                {{ t('ICERIK.DIS_BAGLANTI') }}
              </a>
            </li>
          </ul>

          <div class="flex flex-wrap gap-2">
            <Button
              v-if="duzenlenebilir(gonderi)"
              size="sm"
              variant="faded"
              icon="i-lucide-pen-line"
              :label="t('ICERIK.DUZENLE')"
              @click="duzenle"
            />
            <Button
              size="sm"
              variant="ghost"
              color="slate"
              icon="i-lucide-layout-list"
              :label="t('ICERIK.LISTEDE_AC')"
              @click="listedeAc"
            />
          </div>
        </template>
      </aside>
    </div>
  </div>
</template>
